import type {ISbStoriesParams} from "storyblok-js-client";

import type {MaybeRef} from "vue";
import {unref} from "vue";

export type ReffedParameters = {
	[K in keyof ISbStoriesParams]: MaybeRef<ISbStoriesParams[K]>;
};

export const unrefParameters = (
	parameters: ReffedParameters,
): ISbStoriesParams => {
	const concreteParameters: ISbStoriesParams = {};
	for (const [key, value] of Object.entries(parameters)) {
		concreteParameters[key as keyof ISbStoriesParams] = unref(value);
	}
	return concreteParameters;
};
